export default "__VITE_ASSET__j5gM9th5__"